export const readableHullCoverage = {
    'F. All Risks Basis': 'Full Coverage (Ground & Flight)',
    'G. All Risks Basis Not In Flight': 'Ground Not In Flight',
    'H. All Risks Basis Not In Motion': 'Ground Not in Motion'
}